import React from "react";
import logo from "../assets/images/logo.png";

function Header() {
  return (
    <header className=" bg-bgcolor">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-center items-center">
        {/* Logo + Text */}
        <div className="flex items-center gap-3">
          <img
            src={logo}
            alt="AICaret Logo"
            className="w-10 h-10 object-contain"
          />
          <span className="text-xl sm:text-2xl md:text-4xl font-bold text-white font-avant">
            MyBindle
          </span>
        </div>
      </div>
    </header>
  );
}

export default Header;
